import { render, staticRenderFns } from "./SiFileUpload.vue?vue&type=template&id=47fb8588&scoped=true&lang=html&"
import script from "./SiFileUpload.vue?vue&type=script&lang=js&"
export * from "./SiFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./SiFileUpload.vue?vue&type=style&index=0&id=47fb8588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fb8588",
  null
  
)

export default component.exports